// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"29878252","455":"7e2ff311","977":"3461d6c9"}[chunkId] + ".chunk.js";
};